import { api } from './client'

import type {
    HttpResponse,
    PaginatedResponse,
    ReceptionHistory,
    ReceptionHistoryDetail,
    ReceptionHistorySearchParams,
} from '@/types/api'

interface SpringPage<T> {
    content: T[]
    totalElements: number
    totalPages: number
    number: number
    size: number
}

function adaptPage<T>(raw?: SpringPage<T>): PaginatedResponse<T> {
    if (!raw) {
        return {
            items: [],
            total: 0,
            page: 1,
            limit: 10,
            totalPages: 0,
        }
    }

    return {
        items: raw.content,
        total: raw.totalElements || 0,
        page: (raw.number || 0) + 1,
        limit: raw.size || 10,
        totalPages: raw.totalPages || 0,
    }
}

export interface ReceptionHistoryQueryParams
    extends ReceptionHistorySearchParams {
    page?: number
    limit?: number
}

/**
 * Fetch reception history list.
 */
export async function fetchReceptionHistory(
    page: number = 1,
    limit: number = 10,
    filters: ReceptionHistorySearchParams = {},
    signal?: AbortSignal
): Promise<PaginatedResponse<ReceptionHistory>> {
    try {
        const { title, customerName, fromDate, toDate, robotId, robotName, unitId } = filters

        const response = await api.get<HttpResponse<SpringPage<ReceptionHistory>>>(
            '/v1/session-info',
            {
                params: {
                    page: page - 1,
                    size: limit,
                    title,
                    customerName,
                    fromDate,
                    toDate,
                    robotId,
                    robotName,
                    unitId,
                },
                signal
            },
        )
        return adaptPage((response.data as any).responseData)
    } catch (error: any) {
        const message = error?.response?.data?.responseMessage || error?.message || 'Đã xảy ra lỗi khi lấy danh sách lịch sử tiếp đón.';
        throw new Error(message);
    }
}

export async function getReceptionHistoryById(
    id: string,
    signal?: AbortSignal
): Promise<ReceptionHistoryDetail> {
    try {
        const response = await api.get<any>(
            `/v1/session-info/${id}`,
            { signal }
        )
        return response.data.responseData
    } catch (error: any) {
        const message = error?.response?.data?.responseMessage || error?.message || 'Đã xảy ra lỗi khi lấy chi tiết lịch sử tiếp đón.';
        throw new Error(message);
    }
}